import { createContext } from 'react'

import { Account } from '@core/models/entities'

type Props = {
  getCurrentAccount: () => Account | undefined
}

export const AuthContext = createContext({} as Props)
